import { useCometState } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { useSelectedSearchMode } from '#pplx/frontend/apps/ask/hooks/selected-search-mode-hooks/useSelectedSearchMode.js';
import { ICON_NAME_TO_ICON_MAP, isFinanceRootUrl, } from '#pplx/frontend/apps/ask/suggest-dropdown/primitives/utils/utils.js';
import { getSuggestedSearchModeIcon } from '#pplx/frontend/ask-models/types/search-modes.js';
import { getBrowserFaviconUrl } from '#pplx/frontend/comet/client/utils.js';
import { getFaviconForUrl } from '#pplx/frontend/common/files/urls.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useCallback } from 'react';
/** Keeps row icons tied to the surrounding mode, independently of an input's mode override. */
export function useSuggestionRowIcon() {
    const selectedSearchMode = useSelectedSearchMode();
    const { sidecarSourceTab: { url: sourceTabUrl }, } = useCometState();
    return useCallback(({ category, icon: iconName, image: imageProp, url }, inputQuery) => {
        if (category === 'shortcuts' && !iconName)
            return { icon: $icon('slash') };
        if (isFinanceRootUrl(url))
            return { icon: $icon('custom-perplexity-chart') };
        const isBlankState = inputQuery.length === 0;
        const mappedIcon = iconName ? ICON_NAME_TO_ICON_MAP[iconName] : null;
        const icon = mappedIcon ??
            (isBlankState ? getSuggestedSearchModeIcon(selectedSearchMode) : $icon('search'));
        if (import.meta.env.VITE_IS_SIDECAR_BUILD && sourceTabUrl && isBlankState) {
            return { icon, image: getBrowserFaviconUrl(sourceTabUrl) };
        }
        return { icon, image: imageProp || (url ? getFaviconForUrl(url) : undefined) };
    }, [selectedSearchMode, sourceTabUrl]);
}
//# sourceMappingURL=useSuggestionRowIcon.js.map